"use client";

import { useSyncExternalStore } from "react";

// External store for "are 2+ nodes selected?" — the answer is computed exactly
// once per real selection change in canvas-root and broadcast to all subscribers
// via useSyncExternalStore. Replaces the old per-node `useStore(selectIsMultiSelect)`
// which scanned the entire nodes array every time the ReactFlow store changed
// (incl. drag RAF frames, data updates, etc).

let isMultiSelect = false;
let selectedCount = 0;
const listeners = new Set<() => void>();

function notify() {
  for (const fn of listeners) {
    try {
      fn();
    } catch {}
  }
}

export function publishSelectionCount(count: number): void {
  const safe = Number.isFinite(count) ? Math.max(0, Math.floor(count)) : 0;
  const next = safe > 1;
  const changed = next !== isMultiSelect || safe !== selectedCount;
  isMultiSelect = next;
  selectedCount = safe;
  if (changed) notify();
}

function subscribe(cb: () => void): () => void {
  listeners.add(cb);
  return () => {
    listeners.delete(cb);
  };
}

function getSnapshot(): boolean {
  return isMultiSelect;
}

function getServerSnapshot(): boolean {
  return false;
}

export function useIsMultiSelect(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}

export function getIsMultiSelectSync(): boolean {
  return isMultiSelect;
}

export function getSelectedCountSync(): number {
  return selectedCount;
}
